import images from "./images";
const encodedId = sessionStorage.getItem('admin_id');
const data = {
    user: {
        name: encodedId ? "Admin" : null,
        img: encodedId ? images.avatar1 : null
    },
    summary: [
        {
            title: 'Sales',
            subtitle: 'Total sales today',
            value: '$1,000',
            percent: 70
        },
        {
            title: 'Orders',
            subtitle: 'Total orders today',
            value: '3000',
            percent: 49
        },
        {
            title: 'Revenue',
            subtitle: 'Total revenue today',
            value: '$678',
            percent: 38
        },
        {
            title: 'Visits',
            subtitle: 'Total visits today',
            value: '2345',
            percent: 55
        }
    ],
    revenueSummary: {
        title: 'Revenue',
        value: '$678',
        chartData: {
            labels: ['May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov'],
            data: [300, 300, 280, 380, 200, 300, 280, 350]
        }
    },
    overall: [
        {
            value: <span style={{ color: '#6a5acd', textDecoration: 'underline' }}>300K</span>,
            title: 'Bookings',
            link: 'https://example.com/bookings'
        },
        {
            value: <span style={{ color: '#6a5acd', textDecoration: 'underline' }}>9.876K</span>,
            title: 'Customers',
            link: 'https://example.com/customers'
        },
        {
            value: <span style={{ color: '#6a5acd', textDecoration: 'underline' }}>1.234K</span>,
            title: 'Service Providers',
            link: '/service-providers'
        },
    ],
    revenueByChannel: [
        {
            title: 'Direct',
            value: 70
        },
        {
            title: 'External search',
            value: 40
        },
        {
            title: 'Referral',
            value: 60
        },
        {
            title: 'Social',
            value: 30
        }
    ],
    revenueByMonths: {
        labels: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
        data: [250, 200, 300, 280, 100, 220, 310, 190, 200, 120, 250, 350]
    }
}

export default data;
